import { login, logout, getAdminInfo } from '@/api/auth'
import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: getUserInfo()
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    if (userInfo) {
      setUserInfo(userInfo)
    }
  }
}

const actions = {
  // 登录
  async login({ commit }, loginData) {
    const { username, password } = loginData
    const res = await login({ username: username.trim(), password })

    if (res.code === 200) {
      const { token } = res.data
      commit('SET_TOKEN', token)
      setToken(token)
      return res
    }
    return Promise.reject(new Error(res.msg || '登录失败'))
  },

  // 获取用户信息
  async getInfo({ commit }) {
    const res = await getAdminInfo()

    if (res.code === 200) {
      commit('SET_USER_INFO', res.data)
      return res.data
    }
    return Promise.reject(new Error('获取用户信息失败'))
  },

  // 登出
  async logout({ commit, dispatch }) {
    await logout()
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
    removeToken()
    removeUserInfo()
    await dispatch('permission/resetRoutes', null, { root: true })
  },

  // 重置Token
  async resetToken({ commit, dispatch }) {
    commit('SET_TOKEN', '')
    commit('SET_USER_INFO', null)
    removeToken()
    removeUserInfo()
    await dispatch('permission/resetRoutes', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}